// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"72":"f9f468ad9f255ff8","92":"5c01a07686f00f1b","214":"857eb4f8d8a00ddb","362":"a3e1dd6b2fa2f982","888":"96181873c95da7c2"}[chunkId] + ".css";
};